import {
    Token,
    GetUserResponse,
} from "@devour/client";
import { SendMessageToOW } from "./useOverwolfInterop";

export const waitForOverwolfAuthHandshake = (token: Token, userData: GetUserResponse, sendMessageToOW: SendMessageToOW, isFreshLogin: boolean = false) => {
    /*
     * This handshake will ensure that the OW app has recieved / set the user data
     * before devourgo requests info about the running game.
     * (i.e. auth data MUST be set before de:ready is sent form devourgo)
     */

    /*
     * Initially wanted to do setup the handshake as a promise, where the listener
     * would resolve the promise, but settled on this to avoid race conditions where we
     * send de:data before the handshake listener is setup.
     */

    // Check if we're actually in Overwolf environment
    const isInOverwolfEnvironment = window.sessionStorage.getItem("isOnOverwolf") === "true";

    // In development or when not in Overwolf, skip the handshake to prevent render loops
    if (!isInOverwolfEnvironment) {
        if (import.meta.env.DEV) {
            console.log("[Handshake] Not in Overwolf environment, skipping handshake");
        }
        // Send data once and mark as ready immediately
        sendMessageToOW({type: "de:data", payload: {token: token, userData }, isLogin: isFreshLogin});
        sendMessageToOW({type: "de:ready"});
        return;
    }

    let handshakeRecieved = false;
    const handshakeListener = (event: MessageEvent) => {
        if (event.data?.payload?.type === "ow:login-handshake") {
            handshakeRecieved = true;
            window.removeEventListener("message", handshakeListener);
        }
    };
    window.addEventListener("message", handshakeListener);
    // Send data immediately once
    sendMessageToOW({type: "de:data", payload: {token: token, userData }, isLogin: isFreshLogin});

    // Will resend data at longer intervals until handshake is received or 2 seconds have passed
    const dataInterval = setInterval(() => {
        sendMessageToOW({type: "de:data", payload: {token: token, userData }, isLogin: isFreshLogin});
    }, 500); // Changed from 100ms to 500ms to reduce message spam
    const killIntervalAt = new Date().getTime() + 2000;
    const intervalId = setInterval(() => {
        if (handshakeRecieved) {
            sendMessageToOW({type: "de:ready"});
            clearInterval(dataInterval);
            clearInterval(intervalId);
        } else if (new Date().getTime() > killIntervalAt) {
            clearInterval(intervalId);
            clearInterval(dataInterval);
            sendMessageToOW({type: "de:ready"});
            window.removeEventListener("message", handshakeListener);
        }
    }, 100);
};